import { useAuthenticatedFetch } from './apiService';
import { snakeToCamelObject } from '../utils/snakeToCamel';

// Define the expected data structure for learn content
export interface LearnContentType {
  id: string;
  title: string;
  description: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  // Add other fields as needed based on your backend response
}

export interface EnrolledUserType {
  name: string;
  email: string | null;
  courseDateStart: string | null;
  courseDateEnd: string | null;
  enrollment: Record<string, unknown> | null;
  enrollmentError: string | null;
}

export const useLearnService = () => {
  const authenticatedFetch = useAuthenticatedFetch();

  return {
    listEnrolledUsers: async (courseId: number): Promise<EnrolledUserType[]> => {
      const res = await authenticatedFetch(`/learn/${courseId}/enrolled-users`);
      if (!res.ok) throw new Error('Failed to fetch enrolled users');
      return snakeToCamelObject(await res.json());
    },
  };
};